import axios from 'axios'

/**
 * 運営から全社へ出すお知らせ。
 *
 * 読むほうはダッシュボードの口（/dashboard）に含まれる。ここは書く側で、
 * 経路表で `/platform-notices` は PLATFORM_SUPER_ADMIN だけに開いている。
 */
const origin = process.env.VUE_APP_API_ORIGIN
const get = path => axios.get(origin + path).then(response => response.data)
const post = (path, payload) =>
  axios.post(origin + path, payload).then(response => response.data)

export default {
  /** 一覧。**期限の切れたものも含む。**出した覚えを確かめられるように。 */
  list () {
    return get('/platform-notices')
  },

  /** 1件出す。掲載を終える日は必須。 */
  publish (payload) {
    return post('/platform-notices', payload)
  },

  /** 出すのをやめる。**行は消さない。** */
  end (id) {
    return post('/platform-notices/' + id + '/end')
  }
}
